import React from 'react';
import { Col, Container, Row, FormCheck } from 'react-bootstrap';
import '../../../styles/ProvisioningInfo.css';
import { HHIEButton } from '../../utility/HHIEButton';

export default function ProvisioningInfo(props) {
    const user = JSON.parse(sessionStorage.getItem("user"));
    return (
        <Container className="style-box">
            <Row>
                <Col><div className="style-final">Final</div></Col>
                <Col><div className="style-final">Date</div></Col>
                <Col><div className="style-final">Comments</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox" style={{ color: (props.pass.overallPassed !== 'PASS') ? 'red' : 'green' }}>{props.pass.overallPassed}</div></Col>
                <Col><div className="style-textbox">{props.pass.readablePassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {props.pass.overallComment !== null && props.pass.overallComment !== ""
                            ? props.pass.overallComment
                            : "None"}
                    </div>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col><div className="style-passes">DCCA</div></Col>
                <Col><div className="style-passes">Date</div></Col>
                <Col><div className="style-passes">Comments</div></Col>
                <Col><div className="style-passes">Don't Check</div></Col>
                <Col><div className="style-passes">Overrider</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox">{props.pass.dccaPassStatus}</div></Col>
                <Col><div className="style-textbox">{props.pass.readableDCCAPassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {props.pass.dccaComment !== null && props.pass.dccaComment !== ""
                            ? props.pass.dccaComment
                            : "None"}
                    </div>
                </Col>
                <Col><FormCheck
                    style={{ textIndent: "20px" }}
                    id={"dcca-no-check"}
                    checked={props.pass.dccaNoCheck}
                    disabled

                /></Col>
                <Col>
                    <div className="style-textbox">{props.pass.dccaOverrider != null && props.pass.dccaOverrider !== ""
                        ? props.pass.dccaOverrider
                        : "None"}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col><div className="style-passes">NPI</div></Col>
                <Col><div className="style-passes">Date</div></Col>
                <Col><div className="style-passes">Comments</div></Col>
                <Col><div className="style-passes">Don't Check</div></Col>
                <Col><div className="style-passes">Overrider</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox">{props.pass.npiPassStatus}</div></Col>
                <Col><div className="style-textbox">{props.pass.readableNPIPassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {props.pass.npiComment !== null && props.pass.npiComment !== ""
                            ? props.pass.npiComment
                            : "None"}
                    </div>
                </Col>
                <Col><FormCheck
                    style={{ textIndent: "20px" }}
                    id={"dcca-no-check"}
                    checked={props.pass.npiNoCheck}
                    disabled

                /></Col>
                <Col>
                    <div className="style-textbox">{props.pass.npiOverrider != null && props.pass.npiOverrider !== ""
                        ? props.pass.npiOverrider
                        : "None"}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col><div className="style-passes">LEIE</div></Col>
                <Col><div className="style-passes">Date</div></Col>
                <Col><div className="style-passes">Comments</div></Col>
                <Col><div className="style-passes">Don't Check</div></Col>
                <Col><div className="style-passes">Overrider</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox">{props.pass.oigPassStatus}</div></Col>
                <Col><div className="style-textbox">{props.pass.readableOIGPassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {props.pass.oigComment !== null && props.pass.oigComment !== ""
                            ? props.pass.oigComment
                            : "None"}
                    </div>
                </Col>
                <Col><FormCheck
                    style={{ textIndent: "20px" }}
                    id={"dcca-no-check"}
                    checked={props.pass.oigNoCheck}
                    disabled

                /></Col>
                <Col>
                    <div className="style-textbox">{props.pass.oigOverrider != null && props.pass.oigOverrider !== ""
                        ? props.pass.oigOverrider
                        :"None"}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col><div className="style-passes">SAM</div></Col>
                <Col><div className="style-passes">Date</div></Col>
                <Col><div className="style-passes">Comments</div></Col>
                <Col><div className="style-passes">Don't Check</div></Col>
                <Col><div className="style-passes">Overrider</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox">{props.pass.samPassStatus}</div></Col>
                <Col><div className="style-textbox">{props.pass.readableSAMPassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {props.pass.samComment !== null && props.pass.samComment !== ""
                            ? props.pass.samComment
                            : "None"}
                    </div>
                </Col>
                <Col><FormCheck
                    style={{ textIndent: "20px" }}
                    id={"dcca-no-check"}
                    checked={props.pass.samNoCheck}
                    disabled

                /></Col>
                <Col>
                    <div className="style-textbox">{props.pass.samOverrider != null && props.pass.samOverrider !== ""
                        ? props.pass.samOverrider
                        : "None"}
                    </div>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                {props.isAdmin &&
                    <HHIEButton
                        onClick={
                            () => { props.setOverride() }
                        }
                        variant="primary"
                        size="sm"
                        title="Override"
                        long="true"
                    />
                }
            </Row>
        </Container>
    )
}